<template>
  <div class="main-container">
    <v-row>
      <v-col cols="6">
        <h1 class="title">{{ $t("productLayerList.title") }}</h1>
      </v-col>
      <v-col cols="6" align="end">
        <v-btn class="new-btn" color="primary" @click="createLayout">
          {{ $t("productLayerList.createButton") }}
        </v-btn>
      </v-col>
    </v-row>
    <div v-if="layerList.length !== 0" class="list-container">
      <v-card
        v-for="(layer, cardIndex) in layerList"
        :key="cardIndex"
        class="list-card"
      >
        <div class="list-item">
          <div class="item-name">{{ layer.title }}</div>
          <div class="item-date">{{ layer.id }}</div>
          <div class="item-edit">
            <v-btn
              :id="`menu-activator-${cardIndex}`"
              variant="text"
              icon="mdi-pencil"
            />
            <v-menu :activator="`#menu-activator-${cardIndex}`">
              <v-list>
                <v-list-item
                  v-for="(item, index) in menuItems"
                  :key="index"
                  :value="index"
                  :append-icon="item.icon"
                  @click="item.action(cardIndex)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-card>
    </div>
    <div class="empty-state" v-else>
      {{ $t("productLayerList.emptyState") }}
    </div>
    <new-layout-modal
      :isEdit="isEditModal"
      :currentLayer="currentLayer"
      :showModalProp="showModalProp"
      @closeModal="closeModal"
      @saveLayout="saveLayout"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import NewLayoutModal from "./NewLayoutModal";

export default {
  name: "ProductLayerList",
  components: {
    NewLayoutModal,
  },
  props: {
    layerList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditModal: false,
      showModalProp: false,
      currentLayer: undefined,
      menuItems: [
        {
          type: "editLayout",
          icon: "mdi-vector-polyline-edit",
          title: this.$t("productLayerList.itemActions.editLayout"),
          action: (index) => this.selectItem(index),
        },
        {
          type: "editName",
          icon: "mdi-pencil",
          title: this.$t("productLayerList.itemActions.editName"),
          action: (index) => this.editName(index),
        },
        {
          type: "removeLayout",
          icon: "mdi-delete",
          title: this.$t("productLayerList.itemActions.delete"),
          action: (index) => this.removeLayer(index),
        },
      ],
    };
  },
  mounted() {
    this.emitter.on("okButtonClicked", this.remove);
  },
  beforeUnmount() {
    this.emitter.off("okButtonClicked", this.remove);
  },
  methods: {
    ...mapActions({
      createLayoutApi: "productLayout/createLayout",
      updateLayoutApi: "productLayout/updateLayout",
      deleteLayoutApi: "productLayout/deleteLayout",
    }),
    selectItem(index) {
      this.$emit("select", index);
    },
    editName(index) {
      this.currentLayer = this.layerList[index];
      this.isEditModal = true;
      this.showModalProp = true;
    },
    removeLayer(index) {
      this.currentLayer = this.layerList[index];
      this.emitter.emit("showBasicModal", {
        title: this.$t("productLayerList.deleteLayerModal.title"),
        description: this.$t("productLayerList.deleteLayerModal.description"),
        cancelButton: this.$t("productLayerList.deleteLayerModal.cancelButton"),
        okButton: this.$t("productLayerList.deleteLayerModal.okButton"),
      });
    },
    remove() {
      this.deleteLayoutApi(this.currentLayer.id)
        .then(() => {
          this.closeModal();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createLayout() {
      this.showModalProp = true;
    },
    saveLayout(isEdit, attrs) {
      if (!isEdit) {
        const payload = {
          title: attrs.name,
          partner_id: attrs.partnerId,
        };
        this.createLayoutApi(payload)
          .then(() => {
            this.closeModal();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const payload = {
          layoutId: this.currentLayer.id,
          body: {
            title: attrs.name,
          },
        };
        this.updateLayoutApi(payload)
          .then(() => {
            this.$emit("updateLayerList");
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    closeModal() {
      this.isEditModal = false;
      this.showModalProp = false;
      this.$emit("updateLayerList");
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin-top: 16px;
  height: calc(100% - 60px);
  .title {
    margin-top: 28px;
  }
  .new-btn {
    margin-top: 28px;
  }
  .list-container {
    .list-card {
      margin-top: 16px;
      height: 64px;
      .list-item {
        height: 64px;
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-weight: 450;
        .item-name {
          width: 280px;
          padding: 0 20px;
          @media (max-width: 1100px) {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .item-date {
          width: fit-content;
        }
        .item-edit {
          .v-menu {
            .v-overlay__content {
              .v-list {
                .v-list-item {
                  display: flex;
                }
              }
            }
          }
        }
      }
    }
  }
  .empty-state {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 16px;
    font-size: 22px;
    font-weight: 550;
    opacity: 0.7;
  }
}
</style>
